<template>
  <div class="col-12 col-md-7">
    <div class="mid-container">
      <NavMenu/>
      <transition name="app-notification-fade">
        <div v-if="notification.visible" :class="['app-notification', notification.type]">
          {{ notification.message }}
        </div>
      </transition>
      <main class="content">
        <div class="row">
          <div class="col-8">
            <div class="tittle-content">
              <img class="subtittle-img" src="../assets/img/calculadora-credito.webp" alt="Calcula tu crédito">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <!-- Formulario de entrada -->
            <form class="table-form" @submit.prevent="calculate">
              <table>
                <tr>
                  <td colspan="2">
                    <div class="mb-2">
                      <label for="capital" class="form-label lbl-form">Capital Crediticio:</label>
                      <input
                        type="text"
                        id="capital"
                        class="input-form"
                        required
                        v-model="form.capital"
                        @input="handleCapitalInput"
                      />
                      <small id="helpId" class="text-muted">El monto mínimo del crédito es de $5,000 mxn</small>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="term" class="form-label lbl-form">Plazo (meses):</label>
                      <select id="term" class="form-select input-form" v-model="form.term">
                        <option value="6">6</option>
                        <option value="12">12</option>
                      </select>
                    </div>
                  </td>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="paymentFrequency" class="form-label lbl-form">Plazo de Pago:</label>
                      <select id="paymentFrequency" class="form-select input-form" v-model="form.paymentFrequency">
                        <option value="semanal">Semanal</option>
                        <option value="catorcenal">Catorcenal</option>
                        <option value="mensual">Mensual</option>
                        <option value="quincenal">Quincenal</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div class="mb-2">
                      <label for="fullname" class="form-label lbl-form">Nombre:</label>
                      <input type="text" id="fullname" class="input-form" v-model="form.fullname" required />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="email" class="form-label lbl-form">Correo:</label>
                      <input type="email" id="email" class="input-form" v-model="form.email" required />
                    </div>
                  </td>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="numberPhone" class="form-label lbl-form">Teléfono:</label>
                      <input type="number" id="numberPhone" class="input-form" v-model="form.numberPhone" required />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="estadoResidencia" class="form-label lbl-form">Estado:</label>
                      <select id="estadoResidencia" class="form-select input-form" v-model="form.estadoResidencia" required>
                        <option value="" disabled>Selecciona</option>
                        <option value="aguascalientes">Aguascalientes</option>
                        <option value="baja_california">Baja California</option>
                        <option value="baja_california_sur">Baja California Sur</option>
                        <option value="campeche">Campeche</option>
                        <option value="chiapas">Chiapas</option>
                        <option value="chihuahua">Chihuahua</option>
                        <option value="ciudad_de_mexico">Ciudad de México</option>
                        <option value="coahuila">Coahuila</option>
                        <option value="colima">Colima</option>
                        <option value="durango">Durango</option>
                        <option value="estado_de_mexico">Estado de México</option>
                        <option value="guanajuato">Guanajuato</option>
                        <option value="guerrero">Guerrero</option>
                        <option value="hidalgo">Hidalgo</option>
                        <option value="jalisco">Jalisco</option>
                        <option value="michoacan">Michoacán</option>
                        <option value="morelos">Morelos</option>
                        <option value="nayarit">Nayarit</option>
                        <option value="nuevo_leon">Nuevo León</option>
                        <option value="oaxaca">Oaxaca</option>
                        <option value="puebla">Puebla</option>
                        <option value="queretaro">Querétaro</option>
                        <option value="quintana_roo">Quintana Roo</option>
                        <option value="san_luis_potosi">San Luis Potosí</option>
                        <option value="sinaloa">Sinaloa</option>
                        <option value="sonora">Sonora</option>
                        <option value="tabasco">Tabasco</option>
                        <option value="tamaulipas">Tamaulipas</option>
                        <option value="tlaxcala">Tlaxcala</option>
                        <option value="veracruz">Veracruz</option>
                        <option value="yucatan">Yucatán</option>
                        <option value="zacatecas">Zacatecas</option>
                      </select>
                    </div>
                  </td>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="empresaTrabajo" class="form-label lbl-form">Empresa:</label>
                      <input type="text" id="empresaTrabajo" class="input-form" v-model="form.empresaTrabajo" required />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="antiguedad" class="form-label lbl-form">Antigüedad:</label>
                      <select id="antiguedad" class="form-select input-form" v-model="form.antiguedad" required>
                        <option value="" disabled>Selecciona</option>
                        <option value="menos_3_meses">Menos de 3 meses</option>
                        <option value="de_3_a_6_meses">De 3 a 6 meses</option>
                        <option value="de_6_meses_a_1_ano">De 6 meses a 1 año</option>
                        <option value="de_1_a_2_anos">De 1 a 2 años</option>
                        <option value="de_2_a_5_anos">De 2 a 5 años</option>
                        <option value="mas_de_5_anos">Más de 5 años</option>
                      </select>
                    </div>
                  </td>
                  <td class="field-col">
                    <div class="mb-2">
                      <label for="sueldo" class="form-label lbl-form">Sueldo Mensual:</label>
                      <input
                        type="text"
                        id="sueldo"
                        class="input-form"
                        required
                        v-model="form.sueldo"
                        @input="handleSueldoInput"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div class="mb-2">
                      <label for="frecuenciaSueldo" class="form-label lbl-form">Cada Cuándo te Pagan:</label>
                      <select id="frecuenciaSueldo" class="form-select input-form" v-model="form.frecuenciaSueldo" required>
                        <option value="" disabled>Selecciona una opción</option>
                        <option value="semanal">Semanal</option>
                        <option value="catorcenal">Catorcenal</option>
                        <option value="mensual">Mensual</option>
                        <option value="quincenal">Quincenal</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </table>

              <div class="row justify-content-between">
                <div class="col-12">
                  <button class="btn-form" type="button" @click="calculate">Créalo</button>
                </div>
                <div class="col-4 col-md-5">
                  <button class="btn-form" type="reset" @click="resetResults">Limpiar</button>
                </div>
                <div class="col-7 col-md-6">
                  <button class="btn-form" type="button" @click="sendQuote()">Enviar por correo</button>
                </div>
              </div>
            </form>
          </div>

          <div class="col-12 col-md-6">
            <!-- Área de resultados -->
            <div class="table-results">
              <table>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Capital Crediticio</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Capital Solicitado:</p>
                        <p class="output-span">{{ results.displayCapital }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Intereses</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Total de Intereses a Pagar:</p>
                        <p class="output-span">{{ results.totalInterest }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Capital Total</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Monto Total con Intereses:</p>
                        <p class="output-span">{{ results.totalCapital }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Tasa de Interés</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Interés Generado:</p>
                        <p class="output-span">25.0%</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Plazo</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Plazo de Pago:</p>
                        <p class="output-span">{{ results.displayTerm }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Pago</label>
                      <div class="output-box d-flex justify-content-between">
                        <p>Monto del Periodo:</p>
                        <p class="output-span">{{ results.pagoPeriodo }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="mb-2">
                      <label class="lbl-form">Monto Total</label>
                      <div class="d-flex justify-content-center">
                        <p class="output-box-total">{{ results.totalAmount }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div id="helpId" class="helpId text-muted">El cálculo presentado es una aproximación y el monto total podría variar</div>
          </div>
        </div>
      </main>
      <FooterSihusel/>
    </div>
  </div>
  <div class="d-none d-md-block col-4">
    <div class="right-container slider-credito-pf">
    </div>
  </div>
</template>


<script>

import NavMenu from './NavMenu.vue';
import FooterSihusel from './FooterSihusel.vue';
// import emailjs from '@emailjs/browser'; // desactivado, ver sendQuote() más abajo

// Backend real (vilna-calculadora-backend): genera el PDF, manda los correos
// y crea/actualiza el lead en Odoo. Ya no se usa EmailJS ni se necesita un
// correo de aviso distinto por request: el backend decide solo a quién avisar
// internamente, así que "Créalo" y "Enviar por correo" mandan siempre el
// correo real del cliente.
const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:9001/send-sihusel';

export default {
  name: 'CalculadoraCreditoComponent',
  components: {
    NavMenu,
    FooterSihusel
  },
  data() {
    return {
      form: {
        capital: '$5,000',
        term: 6,
        paymentFrequency: 'semanal',
        fullname: '',
        email: '',
        numberPhone: '',
        estadoResidencia: '',
        empresaTrabajo: '',
        antiguedad: '',
        sueldo: '',
        frecuenciaSueldo: ''
      },
      results: {
        displayCapital: '$0.00',
        totalInterest: '$0.00',
        totalCapital: '$0.00',
        displayTerm: '0 meses',
        pagoPeriodo: '$0.00',
        totalAmount: '$0.00',
        noPagos: 0
      },
      interestRate: 0.25, // Tasa de interés fija
      notification: {
        visible: false,
        type: 'success',
        message: ''
      }
    };
  },
  methods: {
    //------------------ Lógica para limpiar y obtener valor numérico ------------------
    getNumericValue(value) {
      // Eliminar el símbolo '$' y cualquier coma
      value = value.replace(/[$,]/g, '');
      // Eliminar '.00' al final si existe
      value = value.replace(/\.00$/, '');
      // Convertir a número entero
      return parseInt(value, 10) || 0;
    },

    //------------------ Lógica para formatear input numérico con símbolos '$' y ',' ------------------
    formatCurrency(value) {
      // Eliminar cualquier carácter que no sea número
      value = value.replace(/\D/g, '');
      // Convertir a número entero
      value = parseInt(value, 10);
      // Si el valor es un número, formatearlo
      return !isNaN(value) ? `$${value.toLocaleString('en-US')}` : '';
    },

    //------------------ Evento input para formatear el valor en tiempo real ------------------
    handleCapitalInput(event) {
      const formattedValue = this.formatCurrency(event.target.value);
      this.form.capital = formattedValue;
    },

    handleSueldoInput(event) {
      const formattedValue = this.formatCurrency(event.target.value);
      this.form.sueldo = formattedValue;
    },

    //------------------ Lógica para calcular los resultados del crédito ------------------
    // Valida el formulario y actualiza this.results con los montos calculados a partir
    // de los valores actuales. Devuelve false si falta algo (y ya avisó al usuario).
    // La usan tanto "Créalo" como sendQuote(), para que nunca se mande un correo/PDF
    // con resultados en cero por no haber calculado antes.
    runCalculation() {
      const capital = this.getNumericValue(this.form.capital);
      const term = parseInt(this.form.term);

      // Validar inputs
      if (isNaN(capital) || isNaN(term) || !this.form.email || !this.form.fullname || !this.form.numberPhone
          || !this.form.estadoResidencia || !this.form.empresaTrabajo || !this.form.antiguedad
          || !this.form.sueldo || !this.form.frecuenciaSueldo) {
        alert("Por favor, completa todos los campos, incluyendo tu información laboral.");
        return false;
      }

      // Calcular intereses y total a pagar
      const totalInterest = capital * this.interestRate * (term / 12);
      const totalCapital = capital + totalInterest;

      let noPagos;
      switch (this.form.paymentFrequency) {
        case 'semanal':
          noPagos = term * 4;
          break;
        case 'catorcenal':
          noPagos = Math.ceil(term * 2);
          break;
        case 'quincenal':
          noPagos = term * 2;
          break;
        case 'mensual':
        default:
          noPagos = term;
      }

      const pagoPeriodo = totalCapital / noPagos;

      // Actualizar resultados
      this.results.displayCapital = this.formatCurrency(capital.toFixed(0)) + '.00';
      this.results.totalInterest = this.formatCurrency(totalInterest.toFixed(0)) + '.00';
      this.results.totalCapital = this.formatCurrency(totalCapital.toFixed(0)) + '.00';
      this.results.displayTerm = `${term} meses`;
      this.results.pagoPeriodo = this.formatCurrency(pagoPeriodo.toFixed(0)) + '.00';
      this.results.totalAmount = this.formatCurrency(totalCapital.toFixed(0)) + '.00';
      this.results.noPagos = noPagos;

      return true;
    },

    calculate() {
      if (!this.runCalculation()) {
        return;
      }
      this.sendQuote({ silent: true });
    },

    //------------------ Lógica para limpiar los resultados ------------------
    resetResults() {
      this.results.displayCapital = '$0.00';
      this.results.totalInterest = '$0.00';
      this.results.totalCapital = '$0.00';
      this.results.displayTerm = '0 meses';
      this.results.pagoPeriodo = '$0.00';
      this.results.totalAmount = '$0.00';
      this.results.noPagos = 0;

      this.form.capital = '$5,000';
      
      this.form.term = 6;
      this.form.paymentFrequency = 'semanal';
      this.form.fullname = '';
      this.form.email = '';
      this.form.numberPhone = '';
      this.form.estadoResidencia = '';
      this.form.empresaTrabajo = '';
      this.form.antiguedad = '';
      this.form.sueldo = '';
      this.form.frecuenciaSueldo = '';
    },

    //------------------ Lógica para enviar los datos a la API (desactivado temporalmente, ver EmailJS más abajo) ------------------
    // sendQuote() {
    //   const capital = this.getNumericValue(this.form.capital);
    //   const term = this.form.term;
    //   const numberPhone = this.form.numberPhone;
    //   const data = {
    //     cliente: this.form.fullname,
    //     monto_credito: this.formatCurrency(capital.toFixed(0)),
    //     plazo: `${term} meses`,
    //     peridicidad: this.form.paymentFrequency,
    //     total_intereses: this.results.totalInterest,
    //     comision_apertura: '5%',
    //     no_pagos: `${term} pagos`,
    //     pago_total: this.results.totalCapital,
    //     cat: '73.6%',
    //     tasa_interes: '25.0%',
    //     toMail: this.form.email,
    //     numberPhone: numberPhone
    //   };
    //
    //   fetch(process.env.VUE_APP_FINCORE_API_URL, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(data)
    //   })
    //     .then(response => response.json())
    //     .then(responseData => {
    //       if (responseData.statusReport === 'ok' && responseData.statusMail === 'ok') {
    //         alert('La cotización ha sido enviada con éxito.');
    //       } else {
    //         alert('Error al enviar la cotización. Por favor, intente nuevamente.');
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Error:', error);
    //       alert('Error al enviar la cotización. Por favor, intente nuevamente.');
    //     });
    // },
    // Enviar sin notificar cuando el usuario calcule un crédito (desactivado temporalmente, ver EmailJS más abajo)
    // sendQuoteCalculalo() {
    //   const capital = this.getNumericValue(this.form.capital);
    //   const term = this.form.term;
    //   const numberPhone = this.form.numberPhone;
    //   const data = {
    //     cliente: this.form.fullname,
    //     monto_credito: this.formatCurrency(capital.toFixed(0)),
    //     plazo: `${term} meses`,
    //     peridicidad: this.form.paymentFrequency,
    //     total_intereses: this.results.totalInterest,
    //     comision_apertura: '5%',
    //     no_pagos: `${term} pagos`,
    //     pago_total: this.results.totalCapital,
    //     cat: '73.6%',
    //     tasa_interes: '25.0%',
    //     toMail: this.form.email,
    //     numberPhone: numberPhone
    //   };
    //
    //   fetch(process.env.VUE_APP_FINCORE_API_URL, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(data)
    //   })
    //     .then(response => response.json())
    //     .then(responseData => {
    //       if (responseData.statusReport === 'ok' && responseData.statusMail === 'ok') {
    //         // alert('La cotización ha sido enviada con éxito.');
    //       } else {
    //         // alert('Error al enviar la cotización. Por favor, intente nuevamente.');
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Error:', error);
    //       // alert('Error al enviar la cotización. Por favor, intente nuevamente.');
    //     });
    // },

    //------------------ Lógica para enviar los datos por EmailJS (desactivado, ver fetch al backend más abajo) ------------------
    // buildEmailParams() {
    //   const capital = this.getNumericValue(this.form.capital);
    //   const term = this.form.term;
    //   return {
    //     cliente: this.form.fullname,
    //     monto_credito: this.formatCurrency(capital.toFixed(0)),
    //     plazo: `${term} meses`,
    //     peridicidad: this.form.paymentFrequency,
    //     total_intereses: this.results.totalInterest,
    //     comision_apertura: '5%',
    //     no_pagos: `${term} pagos`,
    //     pago_total: this.results.totalCapital,
    //     cat: '73.6%',
    //     tasa_interes: '25.0%',
    //     toMail: this.form.email,
    //     client_email: this.form.email,
    //     numberPhone: this.form.numberPhone
    //   };
    // },
    //
    // sendQuoteViaEmailJs(options = {}) {
    //   const { silent = false, toMailOverride } = options;
    //   if (!silent && !this.isFormValid()) {
    //     this.showNotification('error', 'Por favor, completa nombre, correo, teléfono y capital antes de enviar.');
    //     return;
    //   }
    //   const templateParams = this.buildEmailParams();
    //   if (toMailOverride) {
    //     templateParams.toMail = toMailOverride;
    //   }
    //   emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY)
    //     .then(() => {
    //       if (!silent) {
    //         this.showNotification('success', 'La cotización ha sido enviada con éxito.');
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Error:', error);
    //       if (!silent) {
    //         this.showNotification('error', 'Error al enviar la cotización. Por favor, intenta nuevamente.');
    //       }
    //     });
    // },

    //------------------ Notificación estilizada (reemplaza los alert()) ------------------
    showNotification(type, message) {
      clearTimeout(this._notificationTimer);
      this.notification = { visible: true, type, message };
      this._notificationTimer = setTimeout(() => {
        this.notification.visible = false;
      }, 4000);
    },

    //------------------ Validación manual (los botones son type="button", el required de HTML no aplica) ------------------
    isFormValid() {
      const capital = this.getNumericValue(this.form.capital);
      return !isNaN(capital) && capital > 0 && !!this.form.fullname && !!this.form.email && !!this.form.numberPhone
        && !!this.form.estadoResidencia && !!this.form.empresaTrabajo && !!this.form.antiguedad
        && !!this.form.sueldo && !!this.form.frecuenciaSueldo;
    },

    //------------------ Payload que espera vilna-calculadora-backend (POST /send-sihusel) ------------------
    buildQuotePayload() {
      const capital = this.getNumericValue(this.form.capital);
      const sueldo = this.getNumericValue(this.form.sueldo);
      const term = this.form.term;
      return {
        cliente: this.form.fullname,
        monto_credito: this.formatCurrency(capital.toFixed(0)),
        plazo: `${term} meses`,
        peridicidad: this.form.paymentFrequency,
        total_intereses: this.results.totalInterest,
        comision_apertura: '5%',
        no_pagos: `${this.results.noPagos} pagos`,
        pago_total: this.results.totalCapital,
        pago_periodo: this.results.pagoPeriodo,
        cat: '73.6%',
        tasa_interes: '25.0%',
        client_email: this.form.email,
        numberPhone: this.form.numberPhone,
        estado_residencia: this.form.estadoResidencia,
        empresa_trabajo: this.form.empresaTrabajo,
        antiguedad: this.form.antiguedad,
        sueldo: this.formatCurrency(sueldo.toFixed(0)),
        frecuencia_sueldo: this.form.frecuenciaSueldo
      };
    },

    // Único método de envío. silent=true (usado por "Créalo") no valida de nuevo, no muestra
    // notificación, y le dice al backend que no mande correo al cliente (notify_client=false) —
    // solo deja el aviso interno y el upsert en Odoo. "Enviar por correo" sí manda al cliente.
    sendQuote(options = {}) {
      const { silent = false } = options;

      if (!silent && !this.isFormValid()) {
        this.showNotification('error', 'Por favor, completa todos los campos antes de enviar.');
        return;
      }

      // Recalcula siempre justo antes de armar el payload, para que "Enviar por correo"
      // nunca mande resultados en cero si el usuario nunca dio clic en "Créalo" antes.
      if (!this.runCalculation()) {
        return;
      }

      const payload = this.buildQuotePayload();
      payload.notify_client = !silent;

      fetch(BACKEND_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(responseData => {
          if (responseData.statusMail === 'ok') {
            if (!silent) {
              this.showNotification('success', 'La cotización ha sido enviada con éxito.');
            }
          } else if (!silent) {
            this.showNotification('error', 'Error al enviar la cotización. Por favor, intenta nuevamente.');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          if (!silent) {
            this.showNotification('error', 'Error al enviar la cotización. Por favor, intenta nuevamente.');
          }
        });
    }

  }
};
</script>

<style scoped>
.app-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1050;
  padding: 14px 22px;
  border-radius: 10px;
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  max-width: 320px;
}

.app-notification.success {
  background-color: #F08225;
}

.app-notification.error {
  background-color: #c0392b;
}

.app-notification-fade-enter-active,
.app-notification-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.app-notification-fade-enter-from,
.app-notification-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Compactar el formulario: son varias reglas nuevas (más campos que antes) y
   sin esto el bloque queda mucho más largo que la columna de resultados. Va
   "scoped" para no afectar los demás formularios del sitio que comparten las
   mismas clases .lbl-form/.input-form globales. */
.table-form .field-col {
  width: 42%;
}

.table-form .field-col:first-child {
  width: 58%;
  padding-right: 8px;
}

.table-form .mb-2,
.table-form .mb-3 {
  margin-bottom: 6px !important;
}

.table-form .lbl-form {
  font-size: 14px !important;
  margin-bottom: 2px !important;
  padding-left: 6px !important;
}

.table-form .input-form {
  height: 32px !important;
  font-size: 14px !important;
  padding: 0 12px !important;
}

.table-form small {
  font-size: 11px !important;
  padding-left: 6px !important;
}
</style>
